import React from 'react'
import { Link as SmoothScroll } from 'react-scroll'
import { Accordion } from '@mc/design-system'
import { Trans, useTranslation } from '@mc/i18n'

interface FaqItemProps {
  questionNumber: number
  children: React.ReactNode
}

const FaqItem = ({ questionNumber, children }: FaqItemProps) => {
  const { t } = useTranslation('@mc/next')

  const faqKey = `faq.forBusiness.questions.${questionNumber}`
  const question = t(`${faqKey}.question`)

  return (
    <Accordion.Item
      className='mc-mb-4 mc-text--bold'
      uuid={`${faqKey}.question`}
      label={<span>{question}</span>}
    >
      <div className='mc-opacity--hinted'>
        <Trans i18nKey={`${faqKey}.answer`} ns='@mc/next'>
          <p />
          <p>
            <SmoothScroll
              to='contact-form'
              className='mc-text--link'
              smooth
              offset={-100}
              href='#contact-form'
            >
              {children}
            </SmoothScroll>
          </p>
          <br />
        </Trans>
      </div>
    </Accordion.Item>
  )
}

export default FaqItem
